import { Component, Input } from '@angular/core';
import { DashboardService } from 'app/shared/services/dashboard/dashboard.service';

@Component({
  selector: 'tog-status-indicator',
  templateUrl: './status-indicator.component.html',
  styleUrls: ['./status-indicator.component.scss']
})
export class StatusIndicatorComponent {
  statusOptions: any = this._ds.statusOptions;
  statusIndicatorColor: string = '';

  constructor(private _ds: DashboardService) { }

  @Input() set status(status: string) {
    this.statusIndicatorColor = this._ds.getColorForStatus(status);
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/status-indicator/status-indicator.component.ts